module.exports = __webpack_public_path__ + "img/3.ad99d1d2.jpeg";